function scaleResolutionTo(resolution, spaceWidth) {
  let scaleFactor = spaceWidth / resolution.width
  return {
    width: resolution.width * scaleFactor,
    height: resolution.height * scaleFactor
  }
}

export default scaleResolutionTo